export default "__VITE_ASSET__DWWH4tBx__"